import * as React from "react";
import { Component } from 'react';
import Layout from '../../components/global/layout.js'
import Content from '../../components/championsofchange/subpages/Tori.js'
import '@fortawesome/fontawesome-free/css/all.css';
import '../../sass/app.scss';

class Tori extends Component {
  render() {
    return (
      <>
        <Layout section="community-involvement" page="champion-tori">
          <Content section="community-involvement" page="champion-tori" />
        </Layout>
      </>
    )
  }
}

export default Tori;
